import {Button, FormControlLabel, Grid} from '@material-ui/core';
import {Field, Form, Formik, FormikHelpers} from 'formik';
import * as React from 'react';
import {CreateGroupInput, Group, UpdateGroupInput} from '../../graphql';
import {cleanFormValues, fieldProps} from './Formik';
import {FormikMaterialCheckbox} from './FormikMaterialCheckbox';
import {FormikMaterialTextField} from './FormikMaterialTextField';

interface GroupFormProps {
  onSubmit: Function;
  group?: Group;
}

type Values = Omit<CreateGroupInput, 'clientMutationId'> | Omit<UpdateGroupInput, 'clientMutationId'>;

const initialValues: Values = {
  name: '',
  enabled: false,
};

export const GroupForm = (props: GroupFormProps) => {
  const values = cleanFormValues(props.group, initialValues) as Values;
  return (
    <Formik
      initialValues={props.group ? values : initialValues}
      onSubmit={(
        values: Values,
        {setSubmitting}: FormikHelpers<Values>
      ) => {
        props.onSubmit(values);
        setSubmitting(false);
      }}
    >
      {formik => (
        <Form>
          <Grid container spacing={2}>

            <Grid item xs={12}>
              <Field {...fieldProps('name')} component={FormikMaterialTextField}/>
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                label="Enabled"
                control={
                  <Field name="enabled" component={FormikMaterialCheckbox}/>
                }
              />
            </Grid>

            <Grid item xs={12}>
              <Grid container direction="row-reverse" alignItems="flex-end">
                <Grid item>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                    disabled={!formik.dirty || formik.isSubmitting}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
        </Form>
      )}
    </Formik>
  );
};
